import type { AppState } from "ee/reducers";
export * from "ce/selectors/dataTreeCyclicSelectors";

export const getCurrentEnvironmentName = (state: AppState) =>
  state.environments.currentEnvironmentDetails.name || "";
